import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import Panel from '../../../../shared/components/card/Panel';
import { Row, Col, Tooltip } from 'antd';
import { EventCalenderProps } from '../../../../shared/models/hospitalProfile.model';
import { CalendarEvent } from './../../../../shared/models/hospitalProfile.model';
import moment from 'moment';
import { UPC_DATE_FORMAT } from '../../../../shared/constants/commonConstants';
import NoDataFound from '../../../inventry/shared/NoDataFound';

const UpComingEvents = ({ events }: EventCalenderProps): ReactElement => {
  const [upcEvents, setUpcEvents] = useState(events);
  useEffect((): void => {
    const tempEvents = events?.filter(({ start }: CalendarEvent): boolean => moment(start).isAfter(new Date(), 'date'));
    setUpcEvents(tempEvents);
  }, [events]);
  return (
  <Panel title={'Upcoming Events'}>
      {(upcEvents && upcEvents.length > 0) ? upcEvents.slice(0, 5).map(({ title, start }: CalendarEvent, i: number): ReactNode =>
        <Row key={i} className="upc-item lc-mb0">
          <Col md={16}> <p className="text-elipsis text-capitalize">
            <Tooltip title={title} overlayClassName="text-capitalize">
              {title}
            </Tooltip>
          </p></Col>
          <Col md={8} className="text-end"><p className="fsize_sm gray-text">{moment(start).format(UPC_DATE_FORMAT)}</p> </Col>
        </Row>,
      ) : <NoDataFound />}
  </Panel>
  );
};
export default UpComingEvents;
